import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, MenuItem, Card, Divider, CardContent, IconButton, Chip, Link } from "@mui/material";
import { useGetActionTrackerDetailQuery } from "store/slices/apis/actionTrackerSlice";
import moment from "moment/moment";
import { useDispatch } from "store";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StatusBadge from "components/badge/StatusBadge";
import { DEFAULT_DATE_FORMAT } from "config";
import { useGetActionCommentsQuery } from "store/slices/apis/actionTrackerComment";
import { RxCross2 } from "react-icons/rx";
import ActionTrackerCommentList from "./ActionTrackerCommentList";
import AddCommentTracker from "./AddCommentTracker";

const ViewActionTracker = (props) => {
    const { open, handleClose, rowData } = props;
    console.log(rowData);

    const dispatch = useDispatch();
    const [details, setDetails] = useState(null);
    const [historyData, setHistoryData] = useState([]);

    const { data, isSuccess, isLoading, isError } = useGetActionTrackerDetailQuery(rowData?.projectActionId);
    const { data: historyDatares, isSuccess: historySuccess } = useGetActionCommentsQuery(rowData?.projectActionId);

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    useEffect(() => {
        if (isSuccess && data?.status == "Success") {
            setDetails(data?.data);
        }
    }, [isSuccess, data]);

    useEffect(() => {
        if (isSuccess && !historyDatares?.status) {
            setHistoryData(historyDatares?.data);
        }
    }, [historySuccess, historyDatares]);

    return (
        <Dialog open={open}
            fullScreen
            // maxWidth="xl"
            PaperProps={{
                sx: { borderTopLeftRadius: "3px", borderTopRightRadius: "3px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#FFFFFF",
                pb: 2,
                pt: 2,
                width: "100%",
            }}><Typography sx={{ fontWeight: 600, fontSize: "18px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    View Action Tracker
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: "3px",
                        border: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                        p: 2,
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                        }}
                    >
                        <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                            Action Tracker Information
                        </Typography>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <CardContent sx={{ pt: 0 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                <Grid container spacing={1}>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Sub Project:</Typography>
                                        <Typography sx={valueStyle}>{details?.subProject ?? "N/A"}</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Category:</Typography>
                                        <Typography sx={valueStyle}>{details?.topic ?? "N/A"}</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            Decision Vs Operational:
                                        </Typography>
                                        <Typography sx={valueStyle}>{details?.decisionVsOperational ?? "N/A"}</Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Source:</Typography>
                                        <Typography sx={valueStyle}>{details?.source ?? "N/A"}</Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Responsible / Owner:</Typography>
                                        <Typography sx={valueStyle}>{details?.responsible ?? "N/A"}</Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Priority:</Typography>
                                        <Typography sx={valueStyle}>{details?.priority ?? "N/A"}</Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Action updated date:</Typography>
                                        <Typography sx={valueStyle}>
                                            {details?.updateDate ?
                                                moment(details?.updateDate)?.format(DEFAULT_DATE_FORMAT) ?? "N/A"
                                                :
                                                "-"
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Status:</Typography>
                                        <StatusBadge status={details?.status} />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Assigned to:</Typography>
                                        {/* <Typography sx={valueStyle}>{details?.assignedToName ?? "N/A"}</Typography> */}

                                        {details?.assignedToName?.split(',')?.map((val, key) => (
                                            <Typography key={key} sx={{ fontSize: "16px", fontWeight: 500, color: "#433F5E" }}>
                                                {val}
                                            </Typography>
                                        ))}
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>Closed Date:</Typography>
                                        <Typography sx={valueStyle}>
                                            {details?.closedDate ?
                                                moment(details?.closedDate)?.format(DEFAULT_DATE_FORMAT) ?? "N/A"
                                                :
                                                "-"
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={labelStyle}>Due Date:</Typography>
                                        <Typography sx={valueStyle}>
                                            {details?.revisedDueDate ? (
                                                <>
                                                    {/* Original Due Date */}
                                                    {details?.dueDate ? (
                                                        <Chip
                                                            label={moment(details?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                                            sx={{
                                                                textDecoration: "line-through",
                                                                color: "#e51c1cff",
                                                                backgroundColor: "#f5ccccff",
                                                                fontWeight: 500,
                                                                height: "20px",
                                                                borderRadius: "3px",
                                                                padding: "2px 6px",
                                                                fontFamily: "Outfit",
                                                                fontSize: "12px",
                                                                marginRight: "5px",
                                                            }}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            label="-"
                                                            sx={{
                                                                backgroundColor: "#f5ccccff",
                                                                color: "#e51c1cff",
                                                                height: "20px",
                                                                fontSize: "12px",
                                                                marginRight: "5px",
                                                            }}
                                                        />
                                                    )}
                                                    {!historyData?.length &&
                                                        <Chip
                                                            label={
                                                                details?.revisedDueDate
                                                                    ? moment(details?.revisedDueDate).format(DEFAULT_DATE_FORMAT)
                                                                    : "-"
                                                            }
                                                            sx={{
                                                                color: "#34A853",
                                                                backgroundColor: "#E1FFBB",
                                                                fontWeight: 500,
                                                                height: "20px",
                                                                borderRadius: "3px",
                                                                padding: "2px 6px",
                                                                fontFamily: "Outfit",
                                                                fontSize: "12px",
                                                                marginRight: "5px",
                                                            }}
                                                        />
                                                    }


                                                    {/* History Dates */}
                                                    {historyData
                                                        ?.filter(val => val?.revisedDueDate)
                                                        .reverse()
                                                        .map((val, ind, arr) => {
                                                            const isLast = ind === arr.length - 1;

                                                            return (
                                                                <Chip
                                                                    key={ind}
                                                                    label={moment(val.revisedDueDate).format(DEFAULT_DATE_FORMAT)}
                                                                    sx={{
                                                                        textDecoration: isLast ? "none" : "line-through", // ✅ remove line-through on last
                                                                        color: isLast ? "#34A853" : "#e51c1cff",          // optional: green for last
                                                                        backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                                                        fontWeight: 500,
                                                                        height: "20px",
                                                                        borderRadius: "3px",
                                                                        padding: "2px 6px",
                                                                        fontFamily: "Outfit",
                                                                        fontSize: "12px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                            );
                                                        })}

                                                </>
                                            ) : (
                                                // No revised date → show original or hyphen
                                                moment(details?.dueDate).isValid()
                                                    ? moment(details?.dueDate).format(DEFAULT_DATE_FORMAT)
                                                    : "-"
                                            )}
                                        </Typography>

                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                        <Typography sx={labelStyle}>Description <InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                        <Typography sx={{ ...valueStyle, whiteSpace: "pre-line" }}>{details?.description ?? 'N/A'}</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                        <Typography sx={labelStyle}>Comment/ Identified Challenges/ Problems<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                        <Typography sx={{ ...valueStyle, whiteSpace: "pre-line" }}>{details?.comment ?? 'N/A'}</Typography>
                                    </Grid>
                                    {details?.riskTitle &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated Risk<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customRiskId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.riskTitle}
                                            </Typography>
                                        </Grid>
                                    }
                                    {details?.complianceTitle &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated Compliance<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customComplianceId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.complianceTitle}
                                            </Typography>

                                        </Grid>
                                    }
                                    {details?.procurementSitcTitle &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated Procurement Sitc<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customProcurementSitcId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.procurementSitcTitle}
                                            </Typography>

                                        </Grid>
                                    }
                                    {details?.procurementHotelSitcTitle &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated Procurement Hotel Sitc<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customProcurementHoteSitclId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.procurementHotelSitcTitle}
                                            </Typography>

                                        </Grid>
                                    }
                                    {details?.procurementDPItemTitle &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated Procurement DP Item<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customProcurementDPItemId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.procurementDPItemTitle}
                                            </Typography>

                                        </Grid>
                                    }
                                    {details?.procurementBOItemTitle &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated Procurement BO Item<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customProcurementBOItemId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.procurementBOItemTitle}
                                            </Typography>

                                        </Grid>
                                    }
                                    {details?.ncrLetterNumber &&
                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                            <Typography sx={labelStyle}>Associated NCR<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography>
                                            <Link
                                                component="button"
                                                //onClick={() => handleViewClick(row)}
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {details?.customNCRId}
                                            </Link>
                                            <Typography sx={{ fontSize: "14px" }} >
                                                {details?.ncrLetterNumber}
                                            </Typography>

                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: '90vh', // adjustable
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "3px",
                                    overflow: "auto",
                                }}
                            >

                                <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                                    {/* <Typography sx={labelStyle}>Comments<InfoOutlinedIcon sx={{ fontSize: "14px" }} /></Typography> */}
                                    <ActionTrackerCommentList data={details} />
                                </Box>
                                <Box sx={{ borderTop: "1px solid #e0e0e0", p: 2 }}>
                                    <AddCommentTracker data={details} />
                                </Box>

                            </Grid>

                        </Grid>
                        <Grid container spacing={2}>
                            {/* <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Status:</Typography>
                                <StatusBadge status={details?.status} />
                            </Grid> */}


                            {/* <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Assigned to:</Typography>
                                <Typography sx={valueStyle}>{details?.assignedTo ?? "N/A"}</Typography>
                            </Grid> */}
                            {/* <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Revised Due Date:</Typography>
                                <Typography sx={valueStyle}>
                                    {details?.revisedDueDate ?
                                        <>
                                            <Chip
                                                label={moment(details?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                                sx={{
                                                    textDecoration: "line-through",
                                                    color: "#e51c1cff",
                                                    backgroundColor: "#f5ccccff",
                                                    fontWeight: 500,
                                                    height: "20px",
                                                    borderRadius: "3px",
                                                    padding: "2px 6px",
                                                    fontFamily: "Outfit",
                                                    fontSize: "12px",
                                                    marginRight: '5px'
                                                }}
                                            />
                                            {historyData?.map((val, ind) => {
                                                return (
                                                    <Chip
                                                        key={ind}
                                                        label={moment(val?.revisedDueDate).format(DEFAULT_DATE_FORMAT)}
                                                        sx={{
                                                            // textDecoration: "line-through",
                                                            color: "#e51c1cff",
                                                            backgroundColor: "#f5ccccff",
                                                            fontWeight: 500,
                                                            height: "20px",
                                                            borderRadius: "3px",
                                                            padding: "2px 6px",
                                                            fontFamily: "Outfit",
                                                            fontSize: "12px",
                                                            marginRight: '5px'
                                                        }}
                                                    />
                                                )
                                            })}
                                        </>
                                        :
                                        <>
                                            {moment(details?.dueDate)?.format(DEFAULT_DATE_FORMAT) ?? "N/A"}
                                        </>

                                    }
                                </Typography>
                            </Grid> */}

                            {/* <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                <Typography sx={labelStyle}>Due Date </Typography>
                                {historyData?.map((val, ind) => {
                                    return (
                                        <Chip
                                            key={ind}
                                            label={moment(val?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                            sx={{
                                                textDecoration: "line-through",
                                                color: "#e51c1cff",
                                                backgroundColor: "#f5ccccff",
                                                fontWeight: 500,
                                                height: "20px",
                                                borderRadius: "3px",
                                                padding: "2px 6px",
                                                fontFamily: "Outfit",
                                                fontSize: "12px",
                                                marginRight: '5px'
                                            }}
                                        />
                                    )
                                })}
                            </Grid> */}
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
        </Dialog>
    );
};

export default ViewActionTracker;